import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialState: { topUpHistory: TopUpHistory[] } = {
  topUpHistory: [],
};

export const topUpHistorySlice = createSlice({
  name: "topUpHistory",
  initialState,
  reducers: {
    settopUpHistory: (
      state: { topUpHistory: TopUpHistory[] },
      action: PayloadAction<TopUpHistory[]>
    ) => {
      state.topUpHistory = action.payload;
    },
  },
});

export const { settopUpHistory } = topUpHistorySlice.actions;
export default topUpHistorySlice.reducer;
